import React from 'react';
import { Route } from 'react-router';
import { getCPMapping } from '../../CPMapping';

export const getPDPRoutes = PDPComponent =>
  getCPMapping().products.map(p => (
    <Route
      path={`/${p.categorySeoName}/${p.productSeoName}`}
      render={props => <PDPComponent {...p} {...props} />}
      key={`${p.categorySeoName}-${p.productSeoName}-${p.productId}`}
      exact={true}
    />
  ));
